<template>
  <div class="available" @click="goUrl">
    <div class="desc-box">
      <div class="main-desc">{{list.benefitName}}</div>
      <div class="minor-desc">{{list.benefitDesc}}</div>
    </div>
    <div class="main-detail">
      <div class="text-info">
        <div class="text-box">
          <div class="price">{{price}}</div>
          <div class="detail">{{getCouponDesc(couponBatchList)}}</div>
          <div class="num">{{$t('FoodC_C__n_tBvE', {n: couponBatchList.amount})}}</div>
        </div>
        <div class="img-box">
          <img
            :src="getImgIcon"
            alt=""
          />
        </div>
      </div>
      <div class="use-btn" :class="{'use-btn1':getCountry==='BR'}" @click.stop="goHome">
        <rich-button><span class="use-text">{{$t('FoodC_C_Use_jLVF')}}</span><span class="use-num">({{useText}})</span></rich-button>
      </div>
    </div>
  </div>
</template>

<script>
import {couponPackageAvailableCouponCk} from '../../trackEvent'

import {
  getScheme
} from '@/common/js/utils'
import giftBox99 from '@/assets/images/couponCenter/gift_box99.png'
import giftBoxDidi from '@/assets/images/couponCenter/gift_boxdidi.png'
const COUPON_CENTER_DETAIL_URL = "/${locale}/couponCenterDetail?isBuy=1&nativeWebUIType=1"// eslint-disable-line

export default {
  props: ['list', 'index'],
  data () {
    return {
      DISCOUNT: 100, // 折扣券
      AMOUNT: 3 // 满减券
    }
  },
  computed: {
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    },
    getImgIcon () {
      if (this.getCountry === 'BR') {
        return giftBox99
      } else {
        return giftBoxDidi
      }
    },
    price () {
      // couponType 券类型 3-抵扣券 100-折扣券
      if (this.couponBatchList.couponType == 3) { // eslint-disable-line
        return this.couponBatchList.couponAmountSplit.display
      } else if (this.couponBatchList.couponType == 100) {// eslint-disable-line
        return this.couponBatchList.discountOffText + this.$t('FoodC_C_Off_fkZy')
      }
    },
    useText () {
      return `${this.couponBatchList.availableAmount}/${this.couponBatchList.amount}`
    },
    couponBatchList () {
      return this.list.couponBatchList[0] || {}
    }
  },
  methods: {
    getCouponDesc (val) {
      // 如果是
      if (val.couponType === this.AMOUNT) {
        let moneyText = val.minCostSplit.display
        return val.minCostSplit.number != 0 ? this.$t('FoodC_C_Full_money_oqcE', {money: moneyText}) : this.$t('FoodOpC_Notifications_No_order_CPhU') // eslint-disable-line
      } else if (val.couponType === this.DISCOUNT) {
        let moneyText = val.couponAmountSplit.display
        return this.$t('FoodC_C_Maximum_deduction_UvNt', {money: moneyText})
      }
    },
    goUrl () {
      const params = `&bindID=${this.list.bindID}&saleID=${this.list.saleID}`
      const origin = window.location.origin
      const url = origin + COUPON_CENTER_DETAIL_URL + params
      couponPackageAvailableCouponCk({
        activity_id: this.list.activityID,
        benefit_id: this.list.benefitID,
        available_num: this.list.couponBatchList[0].availableAmount,
        index: this.index * 1
      }, () => {
        window.SodaBridge('openPage', {
          target: 'blank',
          url
        })
      })
    },
    goHome () {
      couponPackageAvailableCouponCk({
        activity_id: this.list.activityID,
        benefit_id: this.list.benefitID,
        available_num: this.list.couponBatchList[0].availableAmount,
        index: this.index * 1
      }, () => {
        location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.available {
  border-radius: 40px;
  overflow: hidden;
  margin-bottom: 24px;
}
.desc-box {
  height: 132px;
  background: #ffffff;
  box-shadow: 0px 16px 20px 0px rgba(168, 168, 168, 0.06);
  padding: 32px 24px 0 24px;
  box-sizing: border-box;
}
.main-desc {
  line-height: 40px;
  font-family: "Aspira Demi";
  font-size: 32px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 8px;
  @extend .ellipsis;
}
.minor-desc {
  font-family: "Aspira Regular";
  font-size: 24px;
  line-height: 26px;
  color: #999999;
  text-align: left;
  font-weight: 400;
  @extend .ellipsis;
}
.main-detail {
  height: 332px;
  border-radius: 0 0 24px 24px ;
  @include new-coupon-bg-gradient();
}
.text-info {
  height: 232px;
  padding: 0 24px 0 24px;
  display: flex;
  justify-content: space-between;
}
.text-box {
  width: 430px;
}
.img-box {
  width: 160px;
  padding-top: 46px;
  img {
    width: 160px;
    height: 160px;
  }
}
.price {
  font-family: "Aspira Demi";
  font-size: 64px;
  color: #000000;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 8px;
  line-height: 66px;
  @extend .ellipsis;
}
.detail {
  font-family: "Aspira Demi";
  font-size: 24px;
  line-height: 26px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 8px;
  @extend .ellipsis;
}
.num {
  font-family: "Aspira Regular";
  font-size: 24px;
  line-height: 26px;
  color: #999999;
  font-weight: 400;
  @extend .ellipsis;
}
.use-btn {
  margin: 0 24px;
}
.use-btn1{
  color: #000;
}
.rich-btn {
  height: 68px;
  font-size: 32px;
  line-height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 18px !important;
  @include new-coupon-package-btn-bg()
}
span {
font-family: 'Aspira Demi';
font-weight: 600;
}
.use-text{
  font-size: 32px;
}
.use-num{
  font-size: 24px;
  margin-left: 8px;
}
</style>
